const trackFields = fields =>
  fields.filter(field => field.gtmTrackingEnabled).map(({ name }) => name)

export default trackFields
